import css from 'styled-jsx/css';

const styles = css.global`#leilao-de-veiculos-passo-a-passo {
  overflow: hidden;
  padding: 40px 0;
  background: #DEEDF2;
}

#leilao-de-veiculos-passo-a-passo .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

#leilao-de-veiculos-passo-a-passo .passo-a-passo-textos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#leilao-de-veiculos-passo-a-passo .passo-a-passo-titulo {
  margin: 0;
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; 
}

#leilao-de-veiculos-passo-a-passo .passo-a-passo-subtitulo,
#leilao-de-veiculos-passo-a-passo .passo-a-passo-carrossel-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#leilao-de-veiculos-passo-a-passo .passo-a-passo-carrossel .custom-carousel {
  margin-top: 24px;
}

#leilao-de-veiculos-passo-a-passo .passo-a-passo-carrossel .slide {
  display: flex;
  gap: 24px;
  align-items: center;
  width: 200px;
  height: 220px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #222;
  margin-right: 24px;
  flex: 0 0 200px;
}

#leilao-de-veiculos-passo-a-passo .passo-a-passo-carrossel .slide .slide-numero {
  color: #C00;
  text-align: center;
  font-family: "SantanderText";
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 60px;
}

#leilao-de-veiculos-passo-a-passo .passo-a-passo-carrossel .slide .slide-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#leilao-de-veiculos-passo-a-passo .home-pagination {
  margin-top: 32px;
  max-width: 248px;
}

#leilao-de-veiculos-passo-a-passo .home-pagination .embla__prev.enable-mobile-arrows, 
#leilao-de-veiculos-passo-a-passo .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#leilao-de-veiculos-passo-a-passo .pagination-container .bullet {
  background-color: #222;
}

#leilao-de-veiculos-passo-a-passo .pagination-container .bullet.active, 
#leilao-de-veiculos-passo-a-passo .pagination-container .bullet[selected] {
  background-color: #c00;
}

@media (min-width: 992px) {
  #leilao-de-veiculos-passo-a-passo .ctn-home-24 {
    gap: 56px;
  }
  
  #leilao-de-veiculos-passo-a-passo .passo-a-passo-titulo {
    font-size: 40px;
    line-height: 60px; 
  }

  #leilao-de-veiculos-passo-a-passo .passo-a-passo-carrossel .custom-carousel {
    margin-top: 16px;
    overflow: hidden;
  }
  
  #leilao-de-veiculos-passo-a-passo .passo-a-passo-carrossel .slide {
    width: 340px;
    height: 124px;
    flex: 0 0 340px;
  }

  #leilao-de-veiculos-passo-a-passo .home-pagination {
    margin-top: 48px;
  }
}`;

export default styles;